import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import css from './FieldBubbles.module.css';

const FieldBubbles = (props) => {
  const { options = [], onChange, value } = props;
  
  const [selectedValues, setSelectedValues] = useState(value || []);


  const handleSelect = (option) => {
    const newSelected = selectedValues.includes(option.option)
      ? selectedValues.filter((v) => v !== option.option)
      : [...selectedValues, option.option];

    setSelectedValues(newSelected);

    if (onChange) {
      onChange(newSelected);
    }
  };

  return (
        <div className={css.bubblesContainer}>
          {options.map((option) => (
            <div
              key={option.option}
              className={classNames(css.bubble, {
                [css.selected]: selectedValues.includes(option.option),
              })}
              onClick={() => handleSelect(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
  );
};

export default FieldBubbles;
